import { render, staticRenderFns } from "./WorkspaceTreeGraphCanvas.vue?vue&type=template&id=e3bc0d74&scoped=true"
import script from "./WorkspaceTreeGraphCanvas.vue?vue&type=script&lang=js"
export * from "./WorkspaceTreeGraphCanvas.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceTreeGraphCanvas.vue?vue&type=style&index=0&id=e3bc0d74&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bc0d74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3bc0d74')) {
      api.createRecord('e3bc0d74', component.options)
    } else {
      api.reload('e3bc0d74', component.options)
    }
    module.hot.accept("./WorkspaceTreeGraphCanvas.vue?vue&type=template&id=e3bc0d74&scoped=true", function () {
      api.rerender('e3bc0d74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceTreeGraphCanvas.vue"
export default component.exports